import moment from "moment";
import { isNumber } from "underscore";
import {
  isOrderInRestaurant,
  isFoodcourt,
} from "util/restaurantUtils";

export const loadTableId = (restaurantId) => {
  try {
    let serializedCart = localStorage.getItem(
      `http://orderbuddy.net.au:${restaurantId}:table`
    );

    if (serializedCart === null) {
      return null;
    }

    return serializedCart;
  } catch (err) {
    return null;
  }
};

export const loadRestaurant = (restaurantId) => {
  try {
    let serializedRestaurant = localStorage.getItem(
      `http://orderbuddy.net.au:${restaurantId}`
    );

    if (serializedRestaurant === null) {
      return null;
    }

    return JSON.parse(serializedRestaurant);
  } catch (err) {
    return null;
  }
};

export const transformOrderId = (reference) => {
  if (reference == null || reference === '') {
    return '';
  }
  const ref =
    typeof reference === 'string' ? reference.trim() : String(reference);
  if (!ref) {
    return '';
  }
  return ref.slice(-4).toUpperCase();
};

/** Trim, strip leading # (common when copying displayed order refs), lowercase. */
export const normalizeOrderSearchText = (text) => {
  if (text == null || typeof text !== 'string') {
    return '';
  }
  return text
    .trim()
    .replace(/^#+/i, '')
    .trim()
    .toLowerCase();
};

export const filterLocalOrders = (orders, now, limit) => {
  return orders.filter((item) => {
    const orderTime = moment(item.orderTime, "DD/MM/YYYY HH:mm:ss");
    const duration = moment.duration(now.diff(orderTime));

    const hours = duration.asHours();
    // console.log('orderTime', orderTime, hours);
    return hours <= limit;
  });
};

export const saveOrdersSummary = (order, restaurant) => {
  try {
    if (!order) {
      return;
    }
    let orders = loadOrdersSummary(restaurant);
    if (!orders) {
      orders = [];
    }
    // console.log("orders", orders, restaurant);
    const todayOrders = filterLocalOrders(orders, moment(), 4);

   // console.log("todayOrders", todayOrders);

    orders = [order, ...todayOrders.slice(0, 10)];
    let serializedOrder = JSON.stringify(orders);
    localStorage.setItem(
      `http://orderbuddy.net.au:${restaurant.restaurantId}:orders`,
      serializedOrder
    );
  } catch (err) {
    console.error(err);
  }
};

export const loadOrdersSummary = (restaurant) => {
  let restaurantId = restaurant;
  if (restaurant.restaurantId) {
    restaurantId = restaurant.restaurantId;
  }
  try {
    let serializedOrder = localStorage.getItem(
      `http://orderbuddy.net.au:${restaurantId}:orders`
    );

    if (serializedOrder === null) {
      return null;
    }
    // console.log("JSON.parse(serializedOrder)", JSON.parse(serializedOrder));
    return JSON.parse(serializedOrder);
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const checkMobilePhone = (mobilePhone) => {
  const number = Number(mobilePhone);
  if (isNaN(number) || !isNumber(number)) {
    return false;
  }
  if (mobilePhone.length === 9 && mobilePhone.startsWith("4")) {
    return true;
  }
  if (mobilePhone.length === 10 && mobilePhone.startsWith("0")) {
    return true;
  }

  return false;
};

export const checkNumber = (inputString) => {
  const number = Number(inputString);
  if (isNaN(number) || !isNumber(number)) {
    return false;
  }
  return true;
};

export const checkAustraliaPostcode = (postcode) => {
  const number = Number(postcode);
  if (isNaN(number) || !isNumber(number)) {
    return false;
  }
  if (postcode.length === 4) {
    return true;
  }

  return false;
};

export const isTakeawayEnabled = (realTableId, restaurantData) => {
  if (isOrderInRestaurant(realTableId)) {
    if (
      restaurantData &&
      restaurantData.onlineSettings &&
      restaurantData.onlineSettings.dineinTakeawayEnabled === true
    ) {
      return true;
    }
  }

  if (isFoodcourt(realTableId)) {
    if (
      restaurantData &&
      restaurantData.onlineSettings &&
      restaurantData.onlineSettings.foodCourtTakeawayEnabled === true
    ) {
      return true;
    }
  }
  return false;
};


export const checkDishIsInActive  = (dish, filteredDishes, todayString) => {
  if (!filteredDishes || filteredDishes.length === 0) {
    return true;
  }

  // The Realtime Database returns an integer-keyed `dishIds` node as an array padded with `null` for any
  // missing index. Reading the shape off `filteredDishes[0]` therefore misread a sparse list as the legacy
  // array-of-ids form and fell through to `indexOf`, which never matches an object — so every sold-out dish
  // silently reappeared on the menu. Drop the holes first, then decide the shape from a real entry.
  const entries = filteredDishes.filter((entry) => entry !== null && entry !== undefined);
  if (entries.length === 0) {
    return true;
  }

  if (typeof entries[0] === 'object' && !Array.isArray(entries[0])) {
    const items = entries.filter((item) => item.menuItemId === dish.id);

    if (items.length > 0 && (items[0].effectiveDate === '' || items[0].effectiveDate === todayString)) {
      return false;
    }

  } else {
    if (entries.indexOf(dish.id) > -1) {
      return false;
    }
  }
  return true;
};


export const filterInactionDishes = (items, filteredDishes) => {
  if (!filteredDishes || filteredDishes.length === 0) {
    return items;
  }
  const todayString = moment().format('YYYY-MM-DD');

  const results = items.filter(dish => {
    return checkDishIsInActive(dish, filteredDishes, todayString);

  });
  
  return results;

};
